import styled from 'styled-components';
import { AccordionFade } from 'components/accordion-fade';

export const Sources = styled(AccordionFade)`
  margin: 32px -24px -48px;
`;
